import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList11Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 86, width: 62 }} viewBox="0 0 62 80">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="8"
          fontWeight="400"
          transform="translate(0 -3)"
        >
          <tspan x="0" y="8">
            ★
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="8"
          fontWeight="400"
          transform="translate(0 -3)"
        >
          <tspan x="0" y="80">
            ★
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -3)"
        >
          <tspan x="11" y="29">
            ○
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -3)"
        >
          <tspan x="11" y="47">
            ○
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -3)"
        >
          <tspan x="22" y="65">
            ■
          </tspan>
        </text>
        <path
          d="M12 6H62V8H12zM12 78H62V80H12zM25 23H62V25H25zM25 41H62V43H25zM33 59H62V61H33z"
          fill={IconColors.Grey}
          transform="translate(0 -3)"
        />
      </g>
    </SvgIcon>
  );
}
